import { render } from "./GlobalImpactHome.vue?vue&type=template&id=1b5e2ff3&scoped=true&lang=en"
import script from "./GlobalImpactHome.vue?vue&type=script&lang=js"
export * from "./GlobalImpactHome.vue?vue&type=script&lang=js"

import "./GlobalImpactHome.vue?vue&type=style&index=0&id=1b5e2ff3&scoped=true&lang=scss"

import exportComponent from "/usr/local/var/www/website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b5e2ff3"]])

export default __exports__